const apiBaseUrl = process.env.NEXT_PUBLIC_API_BASE_URL ?? 'http://127.0.0.1:8787';

export type DailyReportItem = {
  id: number;
  userId: string;
  reportDate: string;
  todayWork: string;
  nextTasks: string;
  userName: string;
  department: string | null;
  createdAt: string;
  updatedAt: string;
};

async function throwIfNotOk(response: Response) {
  if (response.ok) return;
  const payload = await response.json().catch(() => ({}));
  const message = typeof payload.message === 'string' ? payload.message : 'API request failed';
  throw new Error(message);
}

export async function fetchDailyReports(userId: string) {
  const query = new URLSearchParams({ userId });
  const response = await fetch(`${apiBaseUrl}/api/daily-reports?${query.toString()}`);
  await throwIfNotOk(response);
  const payload = (await response.json()) as { reports: DailyReportItem[] };
  return payload.reports;
}

export async function fetchAdminDailyReports(userId?: string) {
  const query = new URLSearchParams();
  if (userId) query.set('userId', userId);
  const suffix = query.toString();
  const response = await fetch(
    `${apiBaseUrl}/api/admin/daily-reports${suffix ? `?${suffix}` : ''}`,
  );
  await throwIfNotOk(response);
  const payload = (await response.json()) as { reports: DailyReportItem[] };
  return payload.reports;
}

export async function upsertDailyReport(input: {
  userId: string;
  reportDate: string;
  todayWork: string;
  nextTasks: string;
}) {
  const response = await fetch(`${apiBaseUrl}/api/daily-reports`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(input),
  });
  await throwIfNotOk(response);
  const payload = (await response.json()) as { report: DailyReportItem };
  return payload.report;
}
